import { Form } from "react-final-form";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import ServiceQualificationModalFormStepOne from "./ServiceQualificationModalFormSteps/ServiceQualificationModalFormStepOne";
import { onSubmit } from "./ServiceQualificationModalFormSubmit";

const ServiceQualificationModalForm = (props) => {
  const theme = useTheme();
  const { step, setStep, initialValues } = props;

  return (
    <Form
      initialValues={{
        customerArrangements: initialValues?.customerArrangements || "",
        requiresAssignment: Boolean(initialValues?.requiresAssignment),
        delayOrder: Boolean(initialValues?.delayOrder),
        performRemotelyNow: Boolean(initialValues?.performRemotelyNow),
      }}
      onSubmit={(val) => onSubmit({ ...val }, props)}
    >
      {(formProps) => (
        <form
          id={props.formName}
          onSubmit={formProps.handleSubmit}
          className="ServiceQualificationModalForm"
        >
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={step}
            onChangeIndex={(index) => setStep(index)}
          >
            <ServiceQualificationModalFormStepOne {...formProps} {...props} />
          </SwipeableViews>
        </form>
      )}
    </Form>
  );
};

export default ServiceQualificationModalForm;
